// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__VB5aR","tooltiptext":"styles_tooltiptext__Qtxw9"};